import React, { useState, useEffect } from 'react';

function AccountTable({accounts}){
    if (accounts.length === 0) {
        return <div>No accounts found.</div>;
    }

    return(
        <div className="row">
            {accounts.map(account =>(
                <div className="col-12 col-lg-6 mb-2">
                    <a href={`/postage-account/${account.postageAccountNumber}`} className="account-tile h-100">
                        <div className="border rounded p-2 h-100" id={account.id}>
                            <div className="row">
                                <div className="col-12">
                                    <div><h3 className="h5"><b class="me-2">{account?.postageAccountNumber}</b>// {account.department}</h3></div>
                                    <ul className="list-unstyled">
                                        <li><b>{account.worktagString}</b></li>
                                        <li></li>
                                        <li>{account.owner ? `${account.owner.firstName} ${account.owner.lastName} // ${account.owner.netId}@uw.edu` : 'No owner assigned'}</li>
                                    </ul>
                                </div>
                            </div>                            
                        </div>
                    </a>
                </div>
            ))}
        </div>
    );
}

export default AccountTable;

/*
<div className="table-responsive">
    <table className="table table-hover align-middle">
        <thead>
        <tr>
            <th>Account Number</th>
            <th>Department</th>
            <th>Worktag String</th>
            <th>Owner (NetId)</th>
            <th>Details</th>
        </tr>
        </thead>
        <tbody>
        {accounts.map(account => (
            <tr key={account.id}>
            <td><b>{account.postageAccountNumber}</b></td>
            <td>{account.department}</td>
            <td>{account.worktagString}</td>
            <td>{account.owner ? `${account.owner.firstName} ${account.owner.lastName} (${account.owner.netID})` : 'No owner assigned'}</td>
            <td><a className="btn btn-sm btn-outline-dark" href={`/postage-account/${account.postageAccountNumber}`}>Details</a></td>
            </tr>
        ))}
        </tbody>
    </table>     
</div>

*/